import {Component} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {catchError, defer, map, Observable, of} from 'rxjs';
import {WebBusinessService} from 'web-angular-client';
import {FloatTopUpBankDetails} from '../../../../../environments/ienvironment';
import {AuthenticationService} from '../../../../sdk/service/authentication.service';
import {EnvironmentService} from '../../../../sdk/service/environment.service';
import {FloatReferenceResult} from './top-up-float-dialog.types';

/**
 * Top Up Float instructions modal. Shows the environment's float bank details alongside the merchant's float
 * reference, loaded from their business. When the business has no reference or the load fails, the details are
 * withheld and an unavailable message is shown instead.
 */
@Component({
    selector: 'app-top-up-float-dialog',
    templateUrl: './top-up-float-dialog.component.html',
    styleUrls: ['./top-up-float-dialog.component.scss'],
    standalone: false
})
export class TopUpFloatDialogComponent
{
    readonly floatReference$: Observable<FloatReferenceResult> = defer(() =>
        this.webBusinessService.getBusinessFromId(this.authenticationService.getUserLogin().businessId)
    ).pipe(
        map((business) => ({reference: business.businessConfig?.floatBankReference || null})),
        catchError(() => of({reference: null}))
    );

    constructor(
        private readonly activeModal: NgbActiveModal,
        private readonly webBusinessService: WebBusinessService,
        private readonly authenticationService: AuthenticationService,
        private readonly environmentService: EnvironmentService)
    {
    }

    get bankDetails(): FloatTopUpBankDetails
    {
        return this.environmentService.floatTopUpBankDetails;
    }

    dismiss(): void
    {
        this.activeModal.dismiss();
    }
}
